import React from 'react';
import { EnrichmentFlowPage } from '../../enrichment/pages/EnrichmentFlowPage';

/**
 * EnrichmentPage - Allows partners to rerun the enrichment process
 * This page skips the company creation step and starts directly at the upload step
 * The EnrichmentFlowPage component automatically detects if company exists and skips onboarding
 */
export const EnrichmentPage: React.FC = () => {
  // EnrichmentFlowPage has its own layout and will automatically skip onboarding
  // if the company already exists (which it should for partners accessing this from dashboard)
  return <EnrichmentFlowPage />;
};

